export class EFinancialAidAwardType {
    public static readonly Initial = 126;
    public static readonly Overall = 127;
    public static readonly Walkon = 128;
    public static readonly Exempt = 129;
}